import React, { forwardRef, InputHTMLAttributes } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: inline-grid;
  vertical-align: top;
  align-items: center;
  position: relative;
  overflow: hidden;
  height: 100%;

  input {
    height: 100%;
    line-height: normal;
  }

  &::after,
  input {
    width: auto;
    min-width: 1em;
    height: inherit;
    grid-area: 1 / 2;
    font: inherit;
    padding: 0;
    margin: 0;
    resize: none;
    background: none;
    appearance: none;
    border: none;
    color: inherit;
  }

  &::after {
    content: attr(data-value);
    visibility: hidden;
    white-space: pre-wrap;
  }

  &:focus-within {
    outline: none;

    input:focus {
      outline: none;
    }
  }

  input::placeholder {
    color: inherit;
  }
`;

const AutosizeInput = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, inputRef) => {
  return (
    <Container
      data-value={props.value || props.defaultValue || props.placeholder}
      className={className}
    >
      <input ref={inputRef} {...props} size={1} />
    </Container>
  );
});

export default AutosizeInput;
